export const menusList = [
  {
    name: '个人信息',
    path: '/userInfo/userInfo',
    icon: 'user'
  },
  {
    name: '我的套餐',
    path: '/userInfo/userProducts',
    icon: 'setting'
  },
  {
    name: '我的订单',
    path: '/userInfo/userOrder',
    icon: 'shop'
  },
  {
    name: '代理分销',
    path: '/userInfo/userRetail',
    icon: 'tickets'
  },
  {
    name: '修改密码',
    path: '/userInfo/userPassword',
    icon: 'pie-chart'
  }
]
